// extracted by mini-css-extract-plugin
module.exports = {"myBackground":"BackgroundCard_myBackground__18fYq","myCard":"BackgroundCard_myCard__AZPk0","myIcon":"BackgroundCard_myIcon__3pkMW","myTitle":"BackgroundCard_myTitle__3awSP"};